module.exports = __webpack_public_path__ + "static/img/6areaA_12.457f565.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/6areaA_12.png
// module id = 916
// module chunks = 1